import "@babel/polyfill";
import "whatwg-fetch"; //Babel polyfill does not know about fetch

import React, { memo, StrictMode, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./App.jsx";

import configureStore from "./../store/configureStore";
import Environment from "./../store/actions/environmentActions";
import OidcContextProvider from "./OidcContext.jsx";

const store = configureStore();

const Index = memo(() => {
	const [dependenciesLoaded, setLoaded] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				await Environment.get()(store.dispatch);

				setLoaded(true);
			} catch (err) {
				console.error(err);
			}
		})();
	}, []);

	return (
		<Provider store={store}>
			<StrictMode>
				{ dependenciesLoaded
						? (
							<OidcContextProvider>
								<HashRouter>
									<App />
								</HashRouter>
							</OidcContextProvider>
						)
						: null
				}
			</StrictMode>
		</Provider>
	);
});
Index.displayName = `Index`;

const main = document.getElementById(`myAppContainer`);
ReactDOM.render(<Index />, main);
